import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TABS = [
  { to: '/marketing-hub/content', label: 'Content Pipeline' },
  { to: '/marketing-hub/content-requests', label: 'Content Requests' },
  { to: '/marketing-hub/competitor-briefing', label: 'Competitor Briefing' },
  { to: '/marketing-hub/opportunity-radar', label: 'Opportunity Radar' },
] as const;

const MarketingHubSubNav: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <nav className="marketing-hub-subnav" aria-label="Marketing Hub">
      <Link to="/marketing-hub" className="mh-subnav-back">
        <ArrowLeft size={14} />
        Marketing Hub
      </Link>
      <div className="mh-subnav-tabs" role="tablist">
        {TABS.map(tab => {
          const active = pathname === tab.to || pathname.startsWith(tab.to + '/');
          return (
            <Link
              key={tab.to}
              to={tab.to}
              role="tab"
              aria-selected={active}
              className={`mh-subnav-tab ${active ? 'active' : ''}`}
            >
              {tab.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MarketingHubSubNav;
